import { AddVitalSignsReport } from "app/screens/residents/show/AddVitalSignsReport";

export default function AddVitalSignsReportPage() {
  return <AddVitalSignsReport />;
}
